<template>
  <div id="wrapper" v-if="timeoff_request_create">
    <div id="content-wrapper" style="">
      <!-- #region TITLE TIME-OFF REQUEST -->
      <div class="time_off_request_header">
        <div
          class=""
          style="width: 90px; min-width: 90px; max-width: 90px; padding-right: 0px; padding-left: 0px; background-color: #2c2c2c; border-radius: 0.3rem;"
        >
          <router-link
            v-if="auth != null && timeoff_request_read"
            :to="`/time_off_request/${this.auth.name}`"
            tag="button"
            class="btn-sm border-0 button--pandora"
            style="width: 90px; padding: 4px 2px 4px 4px;"
          >
            <i
              class="fas fa-arrow-alt-circle-left "
              style="float: left; font-size: 23px;"
            ></i
            >Back</router-link
          >
        </div>
      </div>
      <!--#endregion -->

      <!-- #region TIME-OFF REQUEST -->
      <div id="time_off_request_fluid" class="container-fluid">
        <div class="time_off_request">
          <div class="justify-content-start" style="height: 100%;">
            <!-- #region Employee Time-off Request Form -->
            <b-row
              class=""
              style="height:100%; background-color: #f4f7fc; padding: 0px; margin: 0px; border: 0px solid #ddd; border-radius: 0px 0px 5px 5px;"
            >
              <b-col cols="12" style="padding:0px;">
                <b-card
                  body-class="body_card_custom"
                  class="w-100 ml-auto mr-auto"
                >
                  <b-row class="" style="padding: 0px; margin: 0px;">
                    <b-col cols="12" align-self="center" style="padding:0px;">
                      <p
                        class=""
                        style="margin: 0px 0px 16px 0px; padding: 5px; font-size: 20px; color: #fff; text-align: center; background-color: #5384d1; border: 0px solid #5384d1; border-radius: 5px;"
                      >
                        Create Time-off
                      </p>
                    </b-col>
                  </b-row>
                  <b-row class="" style="padding: 0px; margin: 0px;">
                    <b-col id="fullname_tio_req_form">
                      <b-form-group label-align-sm="left">
                        <template v-slot:label>
                          Full Name
                        </template>
                        <b-form-input
                          type="text"
                          size="sm"
                          v-model="employee.hovaten"
                          disabled
                          required
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row class="" style="padding: 0px; margin: 0px;">
                    <b-col id="linemanager_tio_req_form">
                      <b-form-group label-align-sm="left">
                        <template v-slot:label>
                          Line Manager
                        </template>
                        <b-form-input
                          type="text"
                          size="sm"
                          v-model="employee.lineManager"
                          disabled
                          required
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row class="" style="padding: 0px; margin: 0px;">
                    <b-col id="department_tio_req_form" class="col-9">
                      <b-form-group>
                        <template v-slot:label>
                          Department
                        </template>
                        <b-form-select
                          v-model="employee.departmentId"
                          size="sm"
                          :options="department_list"
                          value-field="id"
                          text-field="tendonvi"
                          disabled
                          required
                        ></b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col id="remain_tio_req_form" class="col-3">
                      <b-form-group label-align-sm="left">
                        <template v-slot:label>
                          Remaining Time-off
                        </template>
                        <b-form-input
                          type="number"
                          size="sm"
                          v-model="employee.remainDays"
                          disabled
                          required
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row class="" style="padding: 0px; margin: 0px;">
                    <b-col id="type_tio_req_form">
                      <b-form-group label-align-sm="left">
                        <template v-slot:label>
                          Time-off type
                          <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                          v-model="timeofftype_select"
                          size="sm"
                          :options="timeofftype_list"
                          value-field="id"
                          text-field="pickListValue"
                          required
                        ></b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <!-- :disabled="
                            findPicklist(
                              profile_status_list,
                              timeoff_req_form.tinhtranghoso
                            ).toUpperCase() != 'ON WORKING'
                          " -->
                  <b-row class="" style="padding: 0px; margin: 0px;">
                    <b-col id="fromdate_tio_req_form">
                      <b-form-group label-align-sm="left">
                        <template v-slot:label>
                          From
                          <span class="text-danger">*</span>
                        </template>
                        <master-date-picker
                          v-model="from_date_picker"
                          required
                        ></master-date-picker>
                      </b-form-group>
                    </b-col>
                    <b-col id="todate_tio_req_form">
                      <b-form-group label-align-sm="left">
                        <template v-slot:label>
                          To
                          <span class="text-danger">*</span>
                        </template>
                        <master-date-picker
                          v-model="to_date_picker"
                          required
                        ></master-date-picker>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row
                    class=""
                    style="padding: 0px; margin: 0px;"
                    :style="{ display: params_stl_dis }"
                  >
                    <b-col id="reasons_tio_req_form">
                      <b-form-group label-align-sm="left">
                        <template v-slot:label>
                          Note
                          <span class="text-danger">*</span>
                        </template>
                        <b-form-textarea
                          v-model="timeoff_req_form.lydo"
                          rows="3"
                          max-rows="3"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row
                    class=""
                    style="padding: 0px; margin: 0px;"
                    :style="{ display: params_wfh_dis }"
                  >
                    <b-col id="reasons_tio_req_form">
                      <b-form-group label-align-sm="left">
                        <template v-slot:label>
                          Reason of work from home
                          <span class="text-danger">*</span>
                        </template>
                        <b-form-textarea
                          v-model="timeoff_req_form.lydo"
                          rows="3"
                          max-rows="3"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row
                    class=""
                    style="padding: 0px; margin: 0px;"
                    :style="{ display: params_wfh_dis }"
                  >
                    <b-col id="task_during_tio_req_form">
                      <b-form-group label-align-sm="left">
                        <template v-slot:label>
                          Task during work from home
                          <span class="text-danger">*</span>
                        </template>
                        <b-form-textarea
                          v-model="timeoff_req_form.taskduringwfh"
                          rows="3"
                          max-rows="3"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row class="" style="padding: 0px; margin: 0px;">
                    <b-col cols="12">
                      <div inline>
                        <b-button
                          variant="info"
                          type="submit"
                          :disabled="disable_save_button"
                          @click.prevent="submitLeave()"
                          style="float:right;"
                        >
                          <i class="fas fa-save mr-2"></i>Save
                        </b-button>
                      </div>
                      <template
                        v-if="
                          timeofftype_select == this.$timeoff_type_workfromhome
                        "
                      >
                        <div inline>
                          <b-button
                            variant="warning"
                            type="submit"
                            :disabled="disable_save_button"
                            @click.prevent="downloadWFHDailyReport()"
                            style="float:right; margin-right: 20px;"
                          >
                            <i class="fas fa-download mr-2"></i>WFH Daily Report
                          </b-button>
                        </div>
                      </template>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
            <!--#endregion -->
          </div>
        </div>
      </div>
      <!--#endregion -->
    </div>

    <!-- #region LOADING MODAL -->
    <b-modal
      id="timeoff_loading_modal"
      v-model="loading_modal_show"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      hide-header
      hide-footer
      centered
    >
      <b-form autocomplete="off">
        <b-row class="" style="padding: 0px; margin: 0px;">
          <b-col cols="12" style="padding:0px; float: left;">
            <div
              style="border: 0px; background: #fff; height: 140px; justify-content: center; align-items: center; display: flex;"
            >
              <template
                v-if="
                  is_storage_timeoff == storage_timeoff_stt.STORAGED &&
                    is_sent_email_timeoff == sent_timeoff_stt.SENT
                "
              >
                <img
                  id="timeoff_approved"
                  src="../assets/Email/approve_icon.png"
                  class="d-inline-block align-center"
                  alt="MeGroup"
                  width="100px"
                />
              </template>
              <template
                v-else-if="
                  (is_storage_timeoff == storage_timeoff_stt.SAVING &&
                    is_sent_email_timeoff == sent_timeoff_stt.UNSEND) ||
                    (is_storage_timeoff == storage_timeoff_stt.STORAGED &&
                      is_sent_email_timeoff == sent_timeoff_stt.SENDING)
                "
              >
                <img
                  id="timeoff_loading"
                  src="../assets/timeoff_loading.gif"
                  class="d-inline-block align-center"
                  alt="MeGroup"
                  width="100px"
                />
              </template>
              <template
                v-else-if="
                  (is_storage_timeoff == storage_timeoff_stt.STORAGED &&
                    is_sent_email_timeoff == sent_timeoff_stt.UNSEND) ||
                    (is_storage_timeoff == storage_timeoff_stt.STORAGED &&
                      is_sent_email_timeoff == sent_timeoff_stt.SEND_ERROR)
                "
              >
                <img
                  id="timeoff_sendmail_error"
                  src="../assets/Email/sendmail_error.png"
                  class="d-inline-block align-center"
                  alt="MeGroup"
                  width="100px"
                />
              </template>
              <template
                v-else-if="
                  is_storage_timeoff == storage_timeoff_stt.STORAGE_ERROR
                "
              >
                <img
                  id="timeoff_error"
                  src="../assets/Email/timeoff_error.jpg"
                  class="d-inline-block align-center"
                  alt="MeGroup"
                  width="100px"
                />
              </template>
            </div>
          </b-col>
        </b-row>
        <b-row class="" style="padding: 0px; margin: 0px;">
          <b-col cols="12" style="padding:0px; float: left;">
            <p
              style="min-height:45px; margin:3px; text-align:center; font-weight:700; font-size:30px; color:#666666; height:"
            >
              <template
                v-if="
                  (is_storage_timeoff == storage_timeoff_stt.STORAGED &&
                    is_sent_email_timeoff == sent_timeoff_stt.SENT) ||
                    (is_storage_timeoff == storage_timeoff_stt.STORAGED &&
                      is_sent_email_timeoff == sent_timeoff_stt.SEND_ERROR) ||
                    (is_storage_timeoff == storage_timeoff_stt.STORAGED &&
                      is_sent_email_timeoff == sent_timeoff_stt.UNSEND)
                "
                >Thank You!
              </template>
              <!-- <template
                v-else-if="
                  is_storage_timeoff == storage_timeoff_stt.UNSAVED &&
                    is_sent_email_timeoff == sent_timeoff_stt.UNSEND
                "
                >Loading!
              </template> -->
              <template
                v-else-if="
                  is_storage_timeoff == storage_timeoff_stt.STORAGE_ERROR
                "
                >Sorry!
              </template>
              <template
                v-else-if="
                  is_storage_timeoff == storage_timeoff_stt.SAVING &&
                    is_sent_email_timeoff == sent_timeoff_stt.UNSEND
                "
                >Saving!
              </template>
              <template
                v-else-if="
                  is_storage_timeoff == storage_timeoff_stt.STORAGED &&
                    is_sent_email_timeoff == sent_timeoff_stt.SENDING
                "
                >Sending mail!
              </template>
            </p>
          </b-col>
        </b-row>
        <b-row class="" style="padding: 0px; margin: 0px;">
          <b-col cols="12" style="padding:0px; float: left;">
            <p
              style="min-height: 45px; margin:3px 0 3px 12px; text-align:center; font-size:16px; color:#666666"
            >
              <template
                v-if="
                  is_storage_timeoff == storage_timeoff_stt.STORAGED &&
                    is_sent_email_timeoff == sent_timeoff_stt.SENT
                "
                >Your submission has been sent.
              </template>
              <template
                v-else-if="
                  is_storage_timeoff == storage_timeoff_stt.STORAGED &&
                    is_sent_email_timeoff == sent_timeoff_stt.UNSEND
                "
              >
                Your submission has been sent.
                <span style="color:#ff0000;">
                  Mail has not been sent!!!
                </span>
              </template>
              <template
                v-else-if="
                  is_storage_timeoff == storage_timeoff_stt.STORAGED &&
                    is_sent_email_timeoff == sent_timeoff_stt.SENDING
                "
              >
                Your submission has been sent.
                <span style="color:#06a730;">
                  Mail is being sent!!!
                </span>
              </template>
              <template
                v-else-if="
                  is_storage_timeoff == storage_timeoff_stt.STORAGED &&
                    is_sent_email_timeoff == sent_timeoff_stt.SEND_ERROR
                "
              >
                Your submission has been sent.
                <span style="color:#ff0000;">
                  But there was an error sending the mail!!!
                </span>
              </template>
              <template
                v-else-if="
                  is_storage_timeoff == storage_timeoff_stt.STORAGE_ERROR
                "
              >
                <span style="color:#ff0000;">
                  An error occurred. {{ res_message }}
                </span>
              </template>
            </p>
          </b-col>
        </b-row>
        <b-row class="" style="padding: 0px; margin: 0px;">
          <b-col
            cols="12"
            align-self="center"
            align="center"
            style="padding:0px; margin-top:10px;"
          >
            <template
              v-if="
                (is_storage_timeoff == storage_timeoff_stt.STORAGED &&
                  is_sent_email_timeoff == sent_timeoff_stt.SENT) ||
                  (is_storage_timeoff == storage_timeoff_stt.STORAGED &&
                    is_sent_email_timeoff == sent_timeoff_stt.SEND_ERROR) ||
                  (is_storage_timeoff == storage_timeoff_stt.STORAGED &&
                    is_sent_email_timeoff == sent_timeoff_stt.UNSEND)
              "
            >
              <b-button
                class="btn btn-timeoff-confirm border-0"
                style=""
                @click.prevent="closeDateModal()"
              >
                Ok
              </b-button>
            </template>
            <template
              v-else-if="
                is_storage_timeoff == storage_timeoff_stt.STORAGE_ERROR
              "
            >
              <b-button
                class="btn btn-timeoff-confirm-error border-0"
                style=""
                @click.prevent="closeDateModal()"
              >
                Ok
              </b-button>
            </template>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <!--#endregion -->
  </div>
</template>

<script>
import axios from "axios";
// import VueDatepickerLocal from "vue-datepicker-local";
import MasterDatePicker from "../components/App/MasterDatePicker";

export default {
  name: "TimeOffRequest",
  components: {
    // VueDatepickerLocal,
    MasterDatePicker,
  },
  props: {},
  data() {
    return {
      from_date_picker: "",
      to_date_picker: "",
      created_date_picker: "",
      timeofftype_select: null,
      params_wfh_dis: "none", // The parameter is only visible for the Work from home type
      params_stl_dis: "none", // The parameter is only visible for the Statutory leave (Wedding leave,...) type
      res_message: "Oops!!!",

      holiday_list: [],
      timeofftype_list: [],
      profile_status_list: [],
      department_list: [],

      employee: {
        employeeId: 0,
        gioitinh: "",
        departmentId: 0,
        lineManager: "",
        lineManagerId: 0,
        manhanvien: "",
        hovaten: "",
        email: null,
        remainDays: 0,
        // donvicongtac: null,
        vitricongviec: null,
        tinhtranghoso: null,
        annualLeaveNotReviewNum: 0,
      },
      timeoff_req_form: {
        id: 0,
        employeeid: 0,
        ngaydenghi: "",
        tungay: "",
        denngay: "",
        lydo: "",
        taskduringwfh: "",
        loainghiphep: null,
        songaynghi: 0,
        trangthaiduyet: 0,
        ngayduyet: "",
        nguoiduyet: 0,
        remainDays: 0,
        manhanvien: null,
        email: null,
      },
      email_form: {
        leaveScheduleId: 0,
        emailBody_parameter: "",
        sendmail_type: "",
      },

      storage_timeoff_stt: {
        UNSAVED: -1,
        SAVING: 0,
        STORAGED: 1,
        STORAGE_ERROR: 2,
      },
      sent_timeoff_stt: {
        UNSEND: -1,
        SENDING: 0,
        SENT: 1,
        SEND_ERROR: 2,
      },

      is_storage_timeoff: -1,
      is_sent_email_timeoff: -1,
      disable_save_button: false,
      loading_modal_show: false,
    };
  },
  computed: {
    //Permission
    auth() {
      return this.$store.state.auth;
    },

    timeoff_request_read() {
      return this.$store.getters.hasPermission("timeoff_request_read");
    },

    timeoff_request_create() {
      return this.$store.getters.hasPermission("timeoff_request_create");
    },
  },
  beforeRouteEnter(to, from, next) {
    axios
      .all([
        axios.get("/api/department"),
        axios.get(`/api/timeoffrequest/employee/${to.params.slug}`),
        axios.get("/api/picklist?q=loainghiphep|tinhtranghoso"),
        axios.get("/api/leaveschedule/holidayColor"),
      ])
      .then(
        axios.spread((department, employee, picklist, holidayColor) => {
          next((vm) =>
            vm.initData(
              department.data,
              employee.data,
              picklist.data,
              holidayColor.data,
              null // not error
            )
          );
        })
      )
      .catch((err) => {
        next((vm) => vm.initData(null, null, null, null, err));
      });
  },
  watch: {
    timeofftype_select(newValue, oldValue) {
      if (newValue != oldValue) {
        switch (newValue) {
          case this.$timeoff_type_paidleave:
          case this.$timeoff_type_unpaidleave:
            this.params_wfh_dis = "none";
            this.params_stl_dis = "none";
            break;
          case this.$timeoff_type_workfromhome:
            this.params_wfh_dis = "flex";
            this.params_stl_dis = "none";
            break;
          case this.$timeoff_type_statutoryleave:
            this.params_stl_dis = "flex";
            this.params_wfh_dis = "none";
            break;
        }
        this.timeoff_req_form.lydo = "";
        this.timeoff_req_form.taskduringwfh = "";
      }
    },

    from_date_picker(newValue, oldValue) {
      if (this.checkValidDate(newValue)) {
        this.timeoff_req_form.songaynghi = this.checkTimeOffDays(
          newValue,
          this.to_date_picker
        );
        if (
          this.timeoff_req_form.songaynghi >
            this.employee.remainDays - this.employee.annualLeaveNotReviewNum &&
          this.timeofftype_select == this.$timeoff_type_paidleave
        ) {
          var exceeded_days =
            this.timeoff_req_form.songaynghi -
            this.employee.remainDays +
            this.employee.annualLeaveNotReviewNum;
          this.$toast.warning(
            `Your Time-off request( ${this.timeoff_req_form.songaynghi} ${
              this.timeoff_req_form.songaynghi == 1 ? " day" : "days"
            }) have exceeded your entitled remaining day is ${exceeded_days} ${
              exceeded_days == 1 ? " day" : "days"
            }
             `,
            "warning",
            {
              timeout: 5000,
            }
          );
        }
      }
    },

    to_date_picker(newValue, oldValue) {
      if (this.checkValidDate(newValue)) {
        this.timeoff_req_form.songaynghi = this.checkTimeOffDays(
          this.from_date_picker,
          newValue
        );
        if (
          this.timeoff_req_form.songaynghi >
            this.employee.remainDays - this.employee.annualLeaveNotReviewNum &&
          this.timeofftype_select == this.$timeoff_type_paidleave // 63
        ) {
          var exceeded_days =
            this.timeoff_req_form.songaynghi -
            this.employee.remainDays +
            this.employee.annualLeaveNotReviewNum;
          this.$toast.warning(
            `Your Time-off request( ${this.timeoff_req_form.songaynghi} ${
              this.timeoff_req_form.songaynghi == 1 ? " day" : "days"
            }) have exceeded your entitled remaining day is ${exceeded_days} ${
              exceeded_days == 1 ? " day" : "days"
            }
             `,
            "warning",
            {
              timeout: 5000,
            }
          );
        }
      }
    },
  },
  // beforeRouteUpdate(to, from, next) {
  // },
  methods: {
    initData(department, employee, picklists, holidayList, err) {
      if (err) {
        this.$toast.error(err.response.data, "Error", { timeout: 10000 });
        this.disable_save_button = true;
        return;
      }
      department.forEach((department) => {
        this.department_list.push(department);
      });
      this.employee = employee;
      this.holiday_list = holidayList;
      picklists.forEach((picklist, index) => {
        switch (picklist.pickListType) {
          case "loainghiphep":
            if (picklist.pickListValue == "Phép") {
              this.timeofftype_list.unshift({
                id: picklist.id,
                pickListType: picklist.pickListType,
                pickListValue: "Paid leave",
              });
            } else if (picklist.pickListValue == "Nghỉ không lương") {
              this.timeofftype_list.unshift({
                id: picklist.id,
                pickListType: picklist.pickListType,
                pickListValue: "Unpaid leave",
              });
            } else {
              this.timeofftype_list.unshift({
                id: picklist.id,
                pickListType: picklist.pickListType,
                pickListValue: picklist.pickListValue,
              });
            }
            break;
          case "tinhtranghoso":
            this.profile_status_list.unshift(picklist);
            break;
        }
      });
      this.timeofftype_list.unshift({
        id: null,
        pickListType: "loainghiphep",
        pickListValue: "Select Time-off type...",
      });

      this.params_wfh_dis = "none";
      this.params_stl_dis = "none";
      this.timeoff_req_form.id = 0;
      this.timeoff_req_form.employeeid = this.employee.employeeId;
      // this.timeoff_req_form.nguoiduyet = this.employee.lineManagerId;
      this.from_date_picker = this.$moment(new Date())
        .format("DD/MM/YYYY")
        .toString();
      this.to_date_picker = this.$moment(new Date())
        .format("DD/MM/YYYY")
        .toString();
      this.created_date_picker = this.$moment(new Date())
        .format("DD/MM/YYYY")
        .toString();
      this.timeoff_req_form.tungay = "";
      this.timeoff_req_form.denngay = "";
      this.timeoff_req_form.ngaydenghi = "";
      this.timeoff_req_form.lydo = "";
      this.timeoff_req_form.taskduringwfh = "";

      if (
        this.findPicklist(
          this.profile_status_list,
          this.employee.tinhtranghoso
        ).toUpperCase() != "ON WORKING"
      ) {
        const index = this.findTimeOffTypeIndexWithID(
          this.timeofftype_list,
          this.$timeoff_type_paidleave
        ); // remove picklist with ID = 63 - Paid Leave ( Nghỉ phép)

        if (index > -1) {
          // only splice array when item is found
          this.timeofftype_list.splice(index, 1); // 2nd parameter means remove one item only
        }
        this.timeoff_req_form.loainghiphep = this.$timeoff_type_unpaidleave; // id: 65 picklist nghi khong luong
      } else {
        this.timeoff_req_form.loainghiphep = null;
      }
      this.timeofftype_select = this.timeoff_req_form.loainghiphep;
      this.timeoff_req_form.tinhtranghoso = this.employee.tinhtranghoso;
      this.timeoff_req_form.trangthaiduyet = 0;
      this.timeoff_req_form.songaynghi = 0;
    },

    //#region SUBMIT METHOD
    submitLeave() {
      this.disable_save_button = true;
      this.loading_modal_show = true;
      this.is_storage_timeoff = this.storage_timeoff_stt.UNSAVED;
      this.is_sent_email_timeoff = this.sent_timeoff_stt.UNSEND;

      if (
        !this.employee.departmentId ||
        !this.timeofftype_select ||
        !this.from_date_picker ||
        !this.to_date_picker ||
        !this.created_date_picker ||
        /*reason and task during WFH only apply to work from home*/
        /*Note only apply to Statutory leave (Wedding leave,...)*/
        ((!this.timeoff_req_form.lydo ||
          !this.timeoff_req_form.taskduringwfh) &&
          this.timeofftype_select == this.$timeoff_type_workfromhome) ||
        (!this.timeoff_req_form.lydo &&
          this.timeofftype_select == this.$timeoff_type_statutoryleave)
      ) {
        this.$toast.error("Please fill out all the information!", "Error", {
          timeout: 2000,
        });
        this.disable_save_button = false;
        this.loading_modal_show = false;
        return;
      }
      if (this.employee.departmentId == null) {
        this.$toast.error("Please select your department!", "Error", {
          timeout: 3000,
        });
        this.disable_save_button = false;
        this.loading_modal_show = false;
        return;
      }
      if (this.timeofftype_select == null) {
        this.$toast.error("Please select leave type!", "Error", {
          timeout: 3000,
        });
        this.disable_save_button = false;
        this.loading_modal_show = false;
        return;
      }
      this.timeoff_req_form.tungay = this.$convert_string_date(
        this.from_date_picker
      );
      this.timeoff_req_form.denngay = this.$convert_string_date(
        this.to_date_picker
      );
      if (this.timeoff_req_form.tungay > this.timeoff_req_form.denngay) {
        this.$toast.error(
          "From Date cannot be greater than To Date!",
          "Error",
          {
            timeout: 3000,
          }
        );
        this.disable_save_button = false;
        this.loading_modal_show = false;
        return;
      }

      this.timeoff_req_form.loainghiphep = this.timeofftype_select;
      if (
        this.timeoff_req_form.loainghiphep != this.$timeoff_type_workfromhome &&
        this.timeoff_req_form.loainghiphep != this.$timeoff_type_statutoryleave
      ) {
        this.timeoff_req_form.lydo = "";
        this.timeoff_req_form.taskduringwfh = "";
      }
      this.timeoff_req_form.ngaydenghi = this.$convert_string_date(
        this.created_date_picker
      );
      this.timeoff_req_form.remainDays = this.employee.remainDays;
      this.timeoff_req_form.trangthaiduyet = 0;
      this.timeoff_req_form.nguoiduyet = null;
      this.timeoff_req_form.ngayduyet = null;
      if (
        this.timeoff_req_form.songaynghi >
          this.employee.remainDays - this.employee.annualLeaveNotReviewNum &&
        this.timeofftype_select == this.$timeoff_type_paidleave //63
      ) {
        var exceeded_days =
          this.timeoff_req_form.songaynghi -
          this.employee.remainDays +
          this.employee.annualLeaveNotReviewNum;
        this.$toast.question(
          `Your Time-off request have exceeded your entitled annual leave day is ${exceeded_days} ${
            exceeded_days == 1 ? " day" : "days"
          }
             `,
          "Warning",
          {
            timeout: 20000,
            close: false,
            overlay: true,
            displayMode: "once",
            position: "center",
            buttons: [
              [
                "<button><b>Yes</b></button>",
                (instance, toast) => {
                  this.storageLeave(this.timeoff_req_form);
                  instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                },
                true,
              ],
              [
                "<button>No</button>",
                (instance, toast) => {
                  instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                },
              ],
            ],
          }
        );
      } else this.storageLeave(this.timeoff_req_form);
      this.disable_save_button = false;
    },

    storageLeave(leave_submit) {
      this.loading_modal_shleavow = true;
      this.is_storage_timeoff = this.storage_timeoff_stt.SAVING;
      this.is_sent_email_timeoff = this.sent_timeoff_stt.UNSEND;

      const payload = {
        model: leave_submit,
      };
      axios
        .post("/api/timeoffrequest", payload)
        .then((res) => {
          //Time-off Request has been created!
          this.employee.annualLeaveNotReviewNum =
            res.data.annualLeaveNotReviewNum;
          this.created_date_picker = this.$moment(new Date())
            .format("DD/MM/YYYY")
            .toString();
          this.timeoff_req_form.id = 0;
          this.timeoff_req_form.loainghiphep = null;
          this.timeoff_req_form.lydo = "";
          this.timeoff_req_form.taskduringwfh = "";
          this.is_storage_timeoff = this.storage_timeoff_stt.STORAGED;
          this.is_sent_email_timeoff = this.sent_timeoff_stt.SENDING;

          const email_form = res.data.emailArr;
          axios
            .post("/api/timeoffrequest/sendmail", email_form)
            .then((res) => {
              //   "Time-off Request has been successfully emailed!",
              this.is_sent_email_timeoff = this.sent_timeoff_stt.SENT;
            })
            .catch((err) => {
              this.res_message = err.response.data;
              this.is_sent_email_timeoff = this.sent_timeoff_stt.SEND_ERROR;
            })
            .finally(() => {
              this.disable_save_button = false;
            });
        })
        .catch((err) => {
          this.res_message = err.response.data;
          this.is_storage_timeoff = this.storage_timeoff_stt.STORAGE_ERROR;
        })
        .finally(() => {
          this.disable_save_button = false;
        });
    },

    downloadWFHDailyReport() {
      this.disable_save_button = true;
      axios({
        method: "get",
        url: `/api/timeoffrequest/downloadwfhdailyreport`,
        responseType: "blob", // important
      })
        .then((res) => {
          let filename = res.headers["content-disposition"]
            .split(";")
            .find(function(el) {
              if (el.includes("filename=")) return el;
            })
            .replace("filename=", "")
            .replaceAll('"', "") // file name có chứa khoảng trắng nên khi gửi tên file từ API sẽ có dấu ""
            .trim();
          const url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.ms-excel;charset=utf-8",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {})
        .finally(() => {
          this.disable_save_button = false;
        });
    },
    //#endregion SUBMIT METHOD

    //#region LOADING METHOD
    closeDateModal() {
      this.loading_modal_show = false;
      this.is_storage_timeoff = this.storage_timeoff_stt.UNSAVED;
      this.is_sent_email_timeoff = this.sent_timeoff_stt.UNSEND;
    },
    //#endregion LOADING METHOD

    //#region FINDING AND CHECKING METHOD
    findPicklist(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.pickListValue;
    },

    findTimeOffTypeIndexWithID(list, id) {
      const temp = list.findIndex(function(val, idx) {
        if (val.id == id) return idx;
      });

      return temp == null ? -1 : temp;
    },

    checkValidDate(str) {
      var t = str.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (t === null) return false;
      var d = parseInt(t[1]),
        m = parseInt(t[2], 10),
        y = parseInt(t[3], 10);
      //below should be more acurate algorithm
      if (m >= 1 && m <= 12 && d >= 1 && d <= 31) {
        return true;
      }
      return false;
    },

    checkTimeOffDays(from_date, to_date) {
      var from_date_convert = this.$convert_string_date(from_date);
      var to_date_convert = this.$convert_string_date(to_date);
      var timeoff_nums = 0;
      for (
        var date = from_date_convert;
        date <= to_date_convert;
        date = this.$moment(date).add(1, "days")
      ) {
        var not_holiday =
          this.holiday_list.filter((item) =>
            item.ngaynghile.includes(
              this.$moment(date).format("YYYY-MM-DD[T]HH:mm:ss")
            )
          ).length > 0
            ? false
            : true;
        var not_weekend = !["Saturday", "Sunday"].includes(
          this.$moment(date)
            .format("dddd")
            .toString()
        );
        if (not_holiday && not_weekend) timeoff_nums += 1;
      }
      return timeoff_nums;
    },
    //#endregion FINDING AND CHECKING METHOD
  },
};
</script>

<style scoped>
.time_off_request_header {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin: 8px 16px 16px 16px;
  list-style: none;
  background-color: #fff;
  border-radius: 0.25rem;
  align-self: center;
  justify-content: flex-start;
  -webkit-justify-content: flex-start;
}

.button--pandora {
  color: #000;
  background-color: #f4f7fc;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

.button--pandora:hover {
  background-color: #ccc;
}
</style>
<style>
#timeoff_loading_modal .modal-dialog {
  min-width: 214px;
}

#timeoff_loading_modal .btn-timeoff-confirm {
  color: #fff;
  border-radius: 4px;
  background: #0ebf00;
  text-decoration: none;
  transition: all 0.4s;
  line-height: 1.5;
  border: none;
  width: calc(100% - 100px);
  width: -webkit-calc(100% - 100px);
  width: -moz-calc(100% - 100px);
}

#timeoff_loading_modal .btn-timeoff-confirm:hover {
  background: #0a8300;
  outline: none;
}

#timeoff_loading_modal .btn-timeoff-confirm:active {
  color: #fff;
  background-color: #075f00;
  border-color: #075f00;
}

#timeoff_loading_modal .btn-timeoff-confirm-error {
  color: #fff;
  border-radius: 4px;
  background: #fb4d4d;
  text-decoration: none;
  transition: all 0.4s;
  line-height: 1.5;
  border: none;
  width: calc(100% - 100px);
  width: -webkit-calc(100% - 100px);
  width: -moz-calc(100% - 100px);
}

#timeoff_loading_modal .btn-timeoff-confirm-error:hover {
  background: #f93939;
  outline: none;
}

#timeoff_loading_modal .btn-timeoff-confirm-error:active {
  color: #fff;
  background-color: #b73838;
  border-color: #b73838;
}

#time_off_request_fluid #master_datepicker__value_ {
  font-size: 0px;
}

#time_off_request_fluid .time_off_request {
  padding: 0px;
  margin: auto;
  color: #000;
  border-radius: 10px;
  background-color: #f4f7fc;
  /* width: 950px; */
  /* width: 50%;
  max-width: 950px;
  min-width: 782px; */
  width: min(100%, 782px);
}

#time_off_request_fluid.container-fluid {
  height: calc(100% - 80px);
  overflow: auto;
}

#time_off_request_fluid .card {
  border: 0px solid #ddd;
  border-radius: 5px;
  min-width: 200px;
}

#time_off_request_fluid .body_card_custom {
  padding: 15px;
}

#time_off_request_fluid .form-control-sm,
.custom-select:disabled,
textarea.form-control {
  font-size: 1rem;
}

/*#region Time-off Request Form*/
#time_off_request_fluid #department_tio_req_form {
  flex: 0 0 calc(100% - 180px);
  max-width: calc(100% - 180px);
}

#time_off_request_fluid #remain_tio_req_form {
  flex: 0 0 180px;
  max-width: 180px;
}
/*#endregion Time-off Request Form*/

@media (max-width: 500px) {
  #time_off_request_fluid #department_tio_req_form,
  #time_off_request_fluid #remain_tio_req_form,
  #time_off_request_fluid #fromdate_tio_req_form,
  #time_off_request_fluid #todate_tio_req_form {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 0px;
  }

  #time_off_request_fluid #fullname_tio_req_form,
  #time_off_request_fluid #linemanager_tio_req_form,
  #time_off_request_fluid #type_tio_req_form,
  #time_off_request_fluid #reasons_tio_req_form {
    padding: 0px;
  }
  #time_off_request_fluid #task_during_tio_req_form {
    padding: 0px;
  }
}
/*#region Scrollbar*/
#time_off_request_fluid::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(109, 118, 126, 0.8);
  border-radius: 10px;
  background-color: #f5f5f5;
}

#time_off_request_fluid::-webkit-scrollbar {
  width: 10px;
  background-color: #f5f5f5;
}

#time_off_request_fluid::-webkit-scrollbar:horizontal {
  height: 13px;
  background-color: #f5f5f5;
}

#time_off_request_fluid::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: hsl(0deg 0% 66%);
}

#time_off_request_fluid::-webkit-scrollbar-thumb:hover {
  box-shadow: inset 0 0 6px rgba(52, 58, 64, 1);
}
/*#endregion Scrollbar*/
</style>
